import { Outlet, createRootRoute } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { useEffect } from "react";
import { errorEvent } from "@/api";
import { useRouter } from "@tanstack/react-router";
import { HeroUIProvider, ToastProvider } from "@heroui/react";
import type { NavigateOptions, ToOptions } from "@tanstack/react-router";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/ko";

dayjs.extend(relativeTime);
dayjs.locale("ko");

declare module "@react-types/shared" {
  interface RouterConfig {
    href: ToOptions["to"];
    routerOptions: Omit<NavigateOptions, keyof ToOptions>;
  }
}

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const router = useRouter();

  useEffect(() => {
    // 카카오 초기화
    if (!window?.Kakao?.isInitialized()) {
      window?.Kakao?.init(import.meta.env.VITE_KAKAO_JS_KEY);
    }

    const sub = errorEvent.subscribe(async (error) => {
      const response = await error.response.clone().json();
      console.error(response);
      // 이부분에서 글로벌 애러처리 가능 뭐 토스트를 띄운다던지
    });

    return () => {
      sub.unsubscribe();
    };
  }, []);

  return (
    <HeroUIProvider
      navigate={(to, options) => router.navigate({ to, ...options })}
      useHref={(to) => router.buildLocation({ to }).href}
    >
      <Outlet />
      <ToastProvider />
      <TanStackRouterDevtools position="bottom-right" />
    </HeroUIProvider>
  );
}
